module.exports = __webpack_public_path__ + "static/media/Button_Players-Status.964fb117.png";